import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';
import { CustomerBillingCustomerModel } from '../customer-billing-customer.model';
import { fiCustomerType } from '../customer-type';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { CustomerService } from '../customer.service';
import { CustomerBillingOtherCustomerModel } from '../../customer-billing-other-customer/customer-billing-other-customer.model';
import { InvoiceType } from '../../customer-billing-invoice/invoice-type';
import { CustomerBillingInvoiceModel } from '../../customer-billing-invoice/customer-billing-invoice.model';
import { CustomerBillingInvoiceDetailModel } from '../../customer-billing-invoice/customer-billing-invoice-detail.model';
import { InvoiceService } from '../../customer-billing-invoice/invoice.service';
import { CustomerBillingInvoiceCreateDialogComponent } from '../../customer-billing-invoice/customer-billing-invoice-create-dialog/customer-billing-invoice-create-dialog.component';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { InvoicesListItemBase } from '@fi-app/customer-billing/customer-billing-customer/invoices-list-item-base';

@Component({
    selector: 'fi-other-invoices-list-item',
    templateUrl: './other-invoices-list-item.component.html',
    styleUrls: ['./other-invoices-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-other-invoices-list-item' },
    standalone: false,
})
export class OtherInvoicesListItemComponent extends InvoicesListItemBase {
    private ownerBillingInfo: CustomerBillingCustomerModel = undefined;

    constructor(injector: Injector) {
        super(injector);
    }

    isOtherInvoiceCreated(customer: CustomerBillingCustomerModel) {
        return customer.CurrentOtherInvoice;
    }

    isOtherInvoiceSent(customer: CustomerBillingCustomerModel) {
        return this.isOtherInvoiceCreated(customer) && !!customer.CurrentOtherInvoice.SentDates.length;
    }

    isOtherInvoicePaid(customer: CustomerBillingCustomerModel) {
        return this.isOtherInvoiceSent(customer) && customer.CurrentOtherInvoice.PaidDate;
    }

    private showInvoiceDialog(customer: CustomerBillingCustomerModel | CustomerBillingOtherCustomerModel) {
        const invoice = new CustomerBillingInvoiceModel({
            InvoiceType: InvoiceType.Other,
        });

        invoice.setOwnerInformation(this.ownerBillingInfo);

        invoice.setCustomerInformation(customer);

        this.fiDialogsService
            .custom({
                hideHeader: true,
                hideFooter: true,
                contentComponentRef: CustomerBillingInvoiceCreateDialogComponent,
                contentComponentData: invoice,
                config: {
                    panelClass: 'fi-customer-billing-invoice-panel',
                    minWidth: '70%',
                    maxWidth: '70%',
                    minHeight: '90%',
                    maxHeight: '90%',
                },
            })
            .onYesButtonClick(() => {
                customer.CurrentOtherInvoice = invoice;
                this.cdr.markForCheck();
            });

        setTimeout(() => {
            invoice.InvoiceDetails.push(
                new CustomerBillingInvoiceDetailModel({
                    InvoiceDetailType: CustomerBillingInvoiceDetailModel.InvoiceDetailTypeInvoiceRow,
                }),
            );
        }, 200);
    }

    createInvoiceWindow(customer: CustomerBillingCustomerModel) {
        if (customer.CustomerType != fiCustomerType.Intranet) {
            const promise = this.customerService.GetOtherBillingCustomer(customer.CustomerId);
            this.fiLoadingService.trackPromise(promise);
            promise.then((response) => {
                this.showInvoiceDialog(response);
            });
        } else this.showInvoiceDialog(customer);
    }

    createOtherInvoice($event, customer: CustomerBillingCustomerModel) {
        $event.stopPropagation();

        if (!this.ownerBillingInfo) {
            const promise = this.customerService.GetCustomer(this.customerDataService.customerData.CustomerId);
            this.fiLoadingService.trackPromise(promise);
            promise.then((response) => {
                this.ownerBillingInfo = response;
                this.createInvoiceWindow(customer);
            });
        } else this.createInvoiceWindow(customer);
    }

    isAddInvoiceAvailable() {
        return this.customerBillingWriteAccess;
    }

    onInvoiceInfoClick($event: MouseEvent, customer: CustomerBillingCustomerModel) {
        $event.stopPropagation();
        this.fiStateService.go(FiStateNames.CustomerBilling.Invoice.View, { Id: customer.CurrentOtherInvoice.Id });
    }
}
